import React from 'react';

/**
 * Modern Segmented Control / Toggle Pill
 * Used for Gender, Payment Type, Transaction Type etc.
 */
const SegmentedControl = ({ 
  options = [], 
  value, 
  onChange, 
  error, 
  className = "",
  variant = 'light' // light, red-emerald
}) => {
  return (
    <div className={`gender-toggle ${error ? 'border border-danger' : ''} ${className}`}>
      {options.map((opt) => {
        const isString = typeof opt === 'string';
        const label = isString ? opt : opt.label;
        const val = isString ? opt : opt.value;
        const isActive = value === val;
        
        return (
          <div 
            key={val} 
            className={`gender-option ${isActive ? 'active' : ''}`}
            onClick={() => onChange(val)}
          >
            {label}
          </div>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
